import React from 'react';

import clsx from 'clsx';

import FormControl from '@gogame/ui/FormControl';
import FormHelperText from '@gogame/ui/FormHelperText';
import { InputLabel } from '@gogame/ui/InputLabel';
import OutlinedInput from '@gogame/ui/OutlinedInput';
import { makeStyles } from '@gogame/ui/styles';

import { RichTextInput } from './RichTextInput';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexGrow: 1,
    fontFamily: `${theme.typography.fontFamily}`,
  },
}));
export const RichTextFormControl = ({
  name,
  label,
  value,
  error,
  onChange,
  helperText,
  extensions,
  onUpdateEditorCallback,
  autofocus = false,
  showToolbar = false,
  className,
}) => {
  const classes = useStyles();

  return (
    <FormControl
      variant={'outlined'}
      size={'small'}
      error={!!error}
      fullWidth={true}
    >
      <InputLabel htmlFor={name}>{label}</InputLabel>
      <OutlinedInput
        id={name}
        aria-describedby={name}
        variant={'outlined'}
        label={label}
        error={!!error}
        name={name}
        value={value}
        onChange={onChange}
        fullWidth={true}
        inputProps={{
          extensions: extensions,
          autofocus: autofocus,
          onUpdateEditorCallback: onUpdateEditorCallback,
          showToolbar: showToolbar,
          className: className,
        }}
        components={{
          Input: RichTextInput,
        }}
        className={classes.root}
      />
      <FormHelperText id={name}>{error || helperText}</FormHelperText>
    </FormControl>
  );
};
